export default __webpack_public_path__ + "static/media/amiens5.bf10ffc5.jpg";